<hr />
<h2 class="mb-4">Monthly Billing</h2>

<h6 class="mb-4 ms-4 payment-blurb">
  Auto-Renew is included in Monthly Billing.
</h6>

<ng-container [formGroup]="form">

  <label for="confirmMonthlyBilling" [ngClass]="{required: form.get('confirmMonthlyBilling')?.enabled === true}">
    <p-checkbox label="I want to automatically renew the short code(s) indicated above into Monthly Billing after initial payment." formControlName='confirmMonthlyBilling'
      id="confirmMonthlyBilling" [binary]="true" #confirmMonthlyBilling></p-checkbox>
  </label>
  <div *ngIf="submitted && form.get('confirmMonthlyBilling')?.invalid">
    <span class="text-danger">
      Since at least one short code is opted in to Monthly Billing above, you must accept the Monthly Billing terms.
    </span>
  </div>

  <div class="ms-4 mt-2">
    I understand and agree that by checking this box, I authorize the Short Code Registry to bill those short codes on a monthly basis following
    completion of their initial pre-paid term, and that the short codes will remain in Monthly Billing until I explicitly remove them. I also agree that
    these short code(s) are subject to the terms of the Monthly Billing Program as described in the Registrant Sublicense Agreement.
  </div>

</ng-container>